module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-backoffice-driver-license-approval-list row column"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('SearchEntity', {
    attrs: {
      "entity": "drivers"
    },
    model: {
      value: (_vm.search.driver_id),
      callback: function($$v) {
        _vm.$set(_vm.search, "driver_id", $$v)
      },
      expression: "search.driver_id"
    }
  })], 1), _c('div', {
    staticClass: "column"
  }, [_c('SelectizeDocumentType', {
    on: {
      "optionSelected": _vm.selectType,
      "optionRemoved": _vm.unsetType
    }
  })], 1)]), _c('BaseList', {
    attrs: {
      "component": _vm.component,
      "dataLoader": _vm.dataLoader,
      "search": _vm.search,
      "componentType": "license-approval-list"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0ba91f62!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/DriverLicenseApprovalQueue.vue
// module id = 2130
// module chunks = 1